export const GoalSection = (goal, side) => {
  const scorer = goal?.scorerName ?? goal?.scoreName ?? goal?.scorer_name ?? goal?.score_name ?? "Gol";
  const minute = goal?.timeMin ?? goal?.time_min;
  const goalDetail = Number.isFinite(Number(minute)) ? `${scorer} (${minute}')` : scorer;
  const goalIcon = <span className="goal-icon" aria-hidden="true" />;

  return side === "away" ? <>{goalDetail}{goalIcon}</> : <>{goalIcon}{goalDetail}</>;
};
